import { TypoMap } from '../models/searchable-item.model';
import { normalizeDiacritics } from '../utils/diacritics.util';

/**
 * Apply typo corrections + diacritic normalization to a raw query.
 * Typo corrections use word-boundary matching to avoid mid-word damage.
 */
export function preprocessQuery(
  raw: string,
  typos: TypoMap,
  lang: 'de' | 'en' | string
): string {
  if (!raw) return '';
  let s = raw.toLowerCase().trim();

  // Typo correction (word-boundary)
  for (const [typo, correct] of Object.entries(typos)) {
    const re = new RegExp(`\\b${escapeRegex(typo)}\\b`, 'gi');
    s = s.replace(re, correct);
  }

  // Diacritic normalization
  return normalizeDiacritics(s, lang);
}

function escapeRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
